import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import styles from './styles.scss';

export default class IconList extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        link: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        target: PropTypes.string,
      })
    ).isRequired,
  };

  renderEntry = (link, label, target) => {
    if (!link) {
      return label;
    }

    if (typeof link === 'string') {
      return (
        <a href={link} target={target || '_self'} rel="noopener noreferrer">
          {label}
        </a>
      );
    }

    return link;
  };

  render() {
    const { items } = this.props;

    return (
      <ul className={styles.iconlist}>
        {items.map((data, i) => {
          return (
            <Fragment key={i}>
              {data.label && (
                <li>
                  <div className={styles.icon}>
                    <Icon name={data.icon} inline={false} />
                  </div>
                  <div>{this.renderEntry(data.link, data.label, data.target)}</div>
                </li>
              )}
            </Fragment>
          );
        })}
      </ul>
    );
  }
}
